const leaderBoardSkeletonStyle = {
    table_wrapper: `flex flex-col justify-between gap-2 w-full overflow-auto p-4
                    screen-500:max-h-[80vh] screen-500:h-[200px]
    `,
    leaderboard_wrapper: `flex flex-col w-full gap-1`,
    dataRow: `flex rounded-[10px] min-h-[36px] w-full animate-pulse bg-gray-700`,
}

export { leaderBoardSkeletonStyle }
